/**
 * Open-Meteo weather API (free, no key required)
 * https://open-meteo.com/
 */

// WMO Weather interpretation codes → label + lucide icon name
const WMO_MAP = {
  0:  { label: 'Clear',        icon: 'Sun' },
  1:  { label: 'Mostly clear', icon: 'Sun' },
  2:  { label: 'Partly cloudy',icon: 'CloudSun' },
  3:  { label: 'Overcast',     icon: 'Cloud' },
  45: { label: 'Foggy',        icon: 'Cloud' },
  48: { label: 'Foggy',        icon: 'Cloud' },
  51: { label: 'Drizzle',      icon: 'CloudDrizzle' },
  53: { label: 'Drizzle',      icon: 'CloudDrizzle' },
  55: { label: 'Drizzle',      icon: 'CloudDrizzle' },
  61: { label: 'Rain',         icon: 'CloudRain' },
  63: { label: 'Rain',         icon: 'CloudRain' },
  65: { label: 'Heavy rain',   icon: 'CloudRain' },
  71: { label: 'Snow',         icon: 'CloudSnow' },
  73: { label: 'Snow',         icon: 'CloudSnow' },
  75: { label: 'Heavy snow',   icon: 'CloudSnow' },
  77: { label: 'Snow grains',  icon: 'CloudSnow' },
  80: { label: 'Showers',      icon: 'CloudRain' },
  81: { label: 'Showers',      icon: 'CloudRain' },
  82: { label: 'Heavy showers',icon: 'CloudRain' },
  95: { label: 'Thunderstorm', icon: 'CloudLightning' },
  96: { label: 'Thunderstorm', icon: 'CloudLightning' },
  99: { label: 'Thunderstorm', icon: 'CloudLightning' },
};

export function getWeatherMeta(code) {
  return WMO_MAP[code] || { label: 'Unknown', icon: 'Cloud' };
}

/**
 * Fetch weather forecast for a venue on a specific event date.
 * Returns null if the date is out of the 16-day forecast window or no lat/lng.
 */
export async function fetchEventWeather(lat, lng, eventDateISO) {
  if (lat == null || lng == null) return null;

  const dateStr = new Date(eventDateISO).toISOString().split('T')[0];

  const url =
    `https://api.open-meteo.com/v1/forecast` +
    `?latitude=${lat}&longitude=${lng}` +
    `&daily=temperature_2m_max,precipitation_probability_max,weathercode` +
    `&temperature_unit=fahrenheit` +
    `&timezone=auto` +
    `&forecast_days=16`;

  let res;
  try {
    res = await fetch(url);
  } catch {
    return null;
  }
  if (!res.ok) return null;

  const data = await res.json();
  const dayIndex = data.daily.time.indexOf(dateStr);
  if (dayIndex === -1) return null;

  const code = data.daily.weathercode[dayIndex];
  return {
    tempMax: Math.round(data.daily.temperature_2m_max[dayIndex]),
    precipPct: data.daily.precipitation_probability_max[dayIndex] ?? 0,
    ...getWeatherMeta(code),
  };
}
